import { selectShoppingCounts, selectActiveList, shoppingListDisplayName, useAppSelector, useT } from "@reciperoll/core";
import { Link } from "react-router-dom";
import { ShoppingCart, ChevronRight } from "react-feather";

// Compact "you have N things to buy" strip → shopping list. Always shown (even
// when empty) so the list is a stable, one-tap entry point from the home page.
export default function ShoppingListPeek() {
  const t = useT();
  const { total, checked } = useAppSelector(selectShoppingCounts);
  const activeList = useAppSelector(selectActiveList);
  const remaining = total - checked;

  const subtitle =
    total === 0
      ? t("shopping.nothingToBuy")
      : remaining > 0
        ? t("shopping.itemsToBuy", { count: remaining })
        : t("shopping.allTickedOff");

  return (
    <Link
      to="/shopping-list"
      className="flex items-center gap-3 bg-terracotta-wash rounded-2xl px-4 py-3.5 h-full hover:opacity-90 transition-opacity"
    >
      <div className="w-9 h-9 rounded-full bg-terracotta flex items-center justify-center shrink-0">
        <ShoppingCart className="w-[18px] h-[18px] text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-base font-bold text-ink truncate">
          {shoppingListDisplayName(activeList?.name, t)}
        </p>
        <p className="text-sm text-ink-soft">{subtitle}</p>
      </div>
      <ChevronRight className="w-5 h-5 text-ink-faint shrink-0" />
    </Link>
  );
}
